import React from 'react';

import { l } from 'app/scripts/lib/localize';
import { PopOver } from 'app/scripts/views/lib/pop-over';
import { FileLinkComponent } from 'app/src/components/FileLinkComponent/FileLinkComponent';

export const FileLinkHandler = (e: MouseEvent, linkElem: HTMLAnchorElement) => {
  e.preventDefault();
  PopOver.show({
    elem: linkElem,
    getViewTitle() {
      return l(['view title', 'open file link']);
    },
    reactElement: (
      <FileLinkComponent key="FileLinkComponent" url={linkElem.href} />
    ),
  });
};
